import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=550a986e&scoped=true"
import script from "./CatalogSearch.vue?vue&type=script&lang=ts"
export * from "./CatalogSearch.vue?vue&type=script&lang=ts"
import style0 from "./CatalogSearch.vue?vue&type=style&index=0&id=550a986e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550a986e",
  null
  
)

export default component.exports